export default () => (
    <div className="position-relative d-flex align-items-center justify-content-center" role="status">
        <div className="spinner-grow spinner-grow-sm m-2 text-secondary position-absolute " role="status"> <span className="sr-only">Loading...</span> </div>
        <div className="spinner-border m-2 text-dark"> <span className="sr-only">Loading...</span> </div>
    </div>
)